import { useNavigate } from '@remix-run/react'
import { useEffect } from 'react'
import { toast as showToast } from 'sonner'
import { type Toast } from '#app/utils/toast.server.ts'

export function useToast(toast?: Toast | null) {
	const navigate = useNavigate()
	useEffect(() => {
		if (toast) {
			const link = toast.link
			setTimeout(() => {
				showToast[toast.type](toast.title, {
					id: toast.id,
					description: toast.description,
					...(link
						? {
								action: {
									label: link.label,
									onClick: () => navigate(link.href),
								},
							}
						: {}),
				})
			}, 0)
		}
	}, [toast, navigate])
}
